<template>
  <div class="wrap">
    <!-- <div class="login"></div>
    <div class="register"></div> -->
    <div class="content x-bd-ra-6">
      <div class="
          head-toggle
          x-w100p x-p-t-25 x-flex x-row-around x-font-17
          f600
          x-bd-bottom
        ">
        <div :class="['x-p-b-20', type == 'login' ? 'active' : 'item']" @click="fToggleState('login')">
          合作伙伴登录
        </div>
        <!-- <div
          :class="['x-p-b-20', type == 'register' ? 'active' : 'item']"
          @click="fToggleState('register')"
        >
          手机验证码登录
        </div> -->
      </div>
      <div v-if="type == 'login'" class="x-w250 x-m-l-50 x-p-t-30">
        <div class="x-m-t-30">
          <el-input v-model="l_phone" placeholder="请输入您的手机号" maxlength="11" type="tel"></el-input>
        </div>
        <div class="x-m-t-30">
          <el-input v-model="l_pwd" placeholder="请输入您的密码" show-password></el-input>
        </div>
        <div class="x-m-t-30 x-flex" v-if="isShowCode">
          <el-input v-model="l_imgCode" placeholder="请输入图片验证码"></el-input>
          <div class="x-m-l-10">
            <div style="border: none" @click="refreshCode">
              <s-Identify :identifyCode="identifyCode"></s-Identify>
            </div>
          </div>
        </div>
        <!-- <Slider  @onSuccess='fRegSucess'></Slider> -->
        <div class="x-flex x-m-t-50">
          <el-button class="x-w100p" type="primary" @click="login">登录</el-button>
        </div>
      </div>
      <div v-if="type == 'register'" class="x-w250 x-m-l-50 x-p-t-10">
        <div class="x-m-t-30">
          <el-input v-model="r_phone" placeholder="请输入您的手机号" maxlength="11" type="tel"></el-input>
        </div>
        <div class="x-m-t-30 x-flex">
          <el-input v-model="r_imgCode" placeholder="请输入图片验证码"></el-input>
          <div class="x-m-l-10">
            <div style="border: none" @click="refreshCode">
              <s-Identify :identifyCode="identifyCode"></s-Identify>
            </div>
          </div>
        </div>
        <div class="x-m-t-30 x-flex">
          <el-input v-model="r_verCode" placeholder="请输入手机验证码">
            <template slot="append">发送验证码</template>
          </el-input>
          <!-- <div class="x-m-l-10 x-w200">站位</div> -->
        </div>
        <div class="x-flex x-m-t-50">
          <el-button class="x-w100p" type="primary">登录</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxODk1NzEwMjA5OCIsImlhdCI6MTY3NTIzNTg1MywiZXhwIjoxNjc1MzIyMjUzLCJpc3MiOiIxODk1NzEwMjA5OCJ9.yzcTdKm4QdM-ybrghQFjJdWxRsp3VmgwuqydGqq3wubpzbnISivqA_Rn247ahKbkzy58NuaxrDppa35n8zNVrA" -->
<!-- "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxODk1NzEwMjA5OCIsImlhdCI6MTY3NTIzNTg1MywiZXhwIjoxNjc1MzIyMjUzLCJpc3MiOiIxODk1NzEwMjA5OCJ9.yzcTdKm4QdM-ybrghQFjJdWxRsp3VmgwuqydGqq3wubpzbnISivqA_Rn247ahKbkzy58NuaxrDppa35n8zNVrA" -->
<script>
  import SIdentify from "@/components/identify";
  // import Slider from '../components/slider.vue';
  export default {
    components: {
      // Slider
    },
    name: "login",
    data() {
      const validateCode = (rule, value, callback) => {
        if (this.identifyCode !== value) {
          this.loginForm.code = "";
          this.refreshCode();
          callback(new Error("请输入正确的验证码"));
        } else {
          callback();
        }
      };
      return {
        canLogin:false,
        type: "login",
        l_phone: "",
        l_pwd: "",
        l_imgCode: "",
        r_phone: "",
        r_imgCode: "",
        r_verCode: "",
        identifyCodes: "1234567890abcdefghigklmnopqrstuvwxyz",
        identifyCode: "", //找回密码图形验证码
        isShowCode: false, // 是否显示 图片验证码
        inputCodeNum: 0, // 输入验证码的次数
      };
    },
    components: {
      "s-Identify": SIdentify,
    },
    watch: {
      identifyCode(v) {
        this.isDebugLogin && (this.loginForm.code = v);
      },
    },
    created() {

      this.refreshCode();
      this.l_phone = this.bykApi.global.fGetPlatform().partnerInfo.phone;
      // this.l_pwd = this.bykApi.global.fGetPlatform().partnerInfo.phone;


    },

    mounted() {
      const self = this;
      self.identifyCode = "";
      self.makeCode(this.identifyCodes, 4);
    },
    methods: {
      fRegSucess() {
        this.canLogin = true
        // if(this.active == '0'){
        //   this.fOrgUserLogin()
        // }
      },
      randomNum(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
      },
      refreshCode() {
        this.identifyCode = "";
        this.makeCode(this.identifyCodes, 4);

      },
      makeCode(o, l) {
        for (let i = 0; i < l; i++) {
          this.identifyCode +=
            this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
        }
      },
      fToggleState(type) {
        this.type = type;
        this.refreshCode();
        this.l_phone = "";
        this.l_pwd = "";
        this.l_imgCode = "";
        this.r_phone = "";
        this.r_imgCode = "";
        this.r_verCode = "";
      },
      // 登录
      async login() {
        if (!this.l_phone) {
          return this.$message("登录手机号不能为空");
        }
        // let phone = this.l_phone.replace(/\s/g, ""); //去除空格
        // let regs = /^((13[0-9])|(17[0-1,6-8])|(15[^4,\\D])|(18[0-9]))\d{8}$/;
        // if (phone.length != 11) {
        //   return this.$message("手机号长度不够");
        // }
        // if (!regs.test(phone)) {
        //   return this.$message("请输入正确手机号");
        // }
        if (this.l_pwd.length == 0) {
          return this.$message("请输入密码");
        }
        if (this.isShowCode) {
          if (this.l_imgCode.length == 0) {
            return this.$message("请输入图片中的验证码");
          }
          if (this.l_imgCode.length != 4) {
            return this.$message("请输入正确的验证码");
          }
          if (this.l_imgCode != this.identifyCode) {
            return this.$message("验证码错误");
          }
        }
        //
        // sessionStorage.phone = this.l_phone;

        this.bykApi.global.fSetPlatform({
          partnerInfo: {
            phone: this.l_phone,
          },
        });
        console.log(this.bykApi.global.fGetPlatform().partnerInfo.phone)

        // localStorage.setItem("bykPlatform", JSON.stringify(test));
        let res = await this.fBykpartnerLogin();

        if (res.result == "sucess") {
          this.bykApi.global.fSetPlatform({
            partnerInfo: {
              data: res.data[0],
              token: res.token,
            },
          });
          sessionStorage.setItem("path", "/home");
          sessionStorage.setItem("id", "0001");
          // sessionStorage.setItem("loginUserId", "0001");
          sessionStorage.setItem("name", "系统首页");
          // window.sessionStorage.setItem('名称', '数据内容')
          //
          this.$router.push("/home");
        }
        if (this.type == "login") {
          this.inputCodeNum += 1;
          if (this.inputCodeNum >= 3) {
            this.isShowCode = true;
          }
        }
        return this.$message(res.msg);
      },

      // ---------------------- 请求函数 开始 ------------------------

      // 登录
      // async fBykpartnerLogin() {
      //   let postJson = {};
      //   postJson["METHOD_NAME"] = "PARTNER_LOGIN";
      //   postJson["PSW"] = this.l_pwd;
      //   let res = await this.bykApi.postApi.fPostToBykPlatFormoApi(postJson);
      //     console.log(res)
      //   return res.data;
      // },
      // // 登录
      async fBykpartnerLogin() {
        let js = {};
        // postJson["METHOD_NAME"] = "PARTNER_LOGIN";
        js['PARTNER_PHONE'] = this.l_phone
        js["PSW"] = this.l_pwd;
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('PARTNER_LOGIN', js);
        console.log(res)
        return res;
      },

      // ---------------------- 请求函数 结束 ------------------------
    },
  };
</script>

<style lang="less" scoped>
  .wrap {
    width: 100%;
    height: 100vh;
    background-image: url(../../src/assets/img/loginBgimg.png);
    background-size: 100% 100%;
    position: relative;
    z-index: 10;

    .content {
      width: 350px;
      height: 420px;
      background-color: #fff;
      position: absolute;
      z-index: 999;
      top: 50%;
      left: 70%;
      transform: translate(-50%, -50%);
    }

    .item {
      border-bottom: 2px solid transparent;
    }

    .active {
      color: #2c6ff2;
      border-bottom: 2px solid #2c6ff2;
    }

    /deep/ .el-input-group__append {
      background-color: #fff;
      color: #2c6ff2;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/login.vue